import { useCallback } from "react";

import { useMutation, UseMutationResult } from "@tanstack/react-query";
import { AlertColor } from "util/constants";

import axios from "@/configs/axios";

interface DuplicateResponse {
  fileName: string;
  exists: boolean;
}
interface ValidateDuplicateRequest {
  fileNames: string[];
  path: string;
}
interface ValidateDuplicateResult {
  name: string;
  exists: boolean;
}

interface Props {
  callbackError?: (message: string, alertColor: AlertColor) => void;
}

export const usePostValidateDuplications = ({
  callbackError,
}: Props): UseMutationResult<
  ValidateDuplicateResult[],
  Error,
  ValidateDuplicateRequest,
  unknown
> => {
  const callValidateDuplicate = useCallback(
    async (request: ValidateDuplicateRequest): Promise<ValidateDuplicateResult[]> => {
      try {
        const url = `${process.env.REACT_APP_SERVER_HOST}/validateDuplications`;
        const { data } = await axios.post(
          url,
          { path: request.path, file_names: request.fileNames },
          {
            headers: {
              "Cache-Control": "no-store",
            },
          }
        );
        return data.map((res: DuplicateResponse) => ({
          name: res.fileName,
          exists: res.exists,
        }));
      } catch (error: any) {
        if (callbackError) {
          callbackError(error.message, AlertColor.Error);
        }
        return [];
      }
    },
    []
  );

  return useMutation<ValidateDuplicateResult[], Error, ValidateDuplicateRequest, unknown>({
    mutationFn: callValidateDuplicate,
  });
};
